import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
  },
  companyWrapper: {
    boxShadow: '0px 0px 10px rgba(102, 124, 158, 0.3)',
    marginTop: '24px',
    padding: '16px 16px 24px',
    border: '2px solid #afafaf',
    gap: '24px',
    display: 'flex',
    flexDirection: 'column',
  },
  CompanyDropDownWrapper: {
    width: '100%',
  },
  crmIdField: {
    '& .MuiInputBase-root ': { height: '40px' },
    paddingLeft: '8px',
  },
  deleteButton: { padding: '8px 0 0 8px' },
  selected: { paddingLeft: '9px' },
  item: {
    display: 'flex',
    alignItems: 'center',
  },
  name: {
    width: '50%',
    paddingRight: '4px',
  },
  companiesDropDawn: {
    display: 'flex',
    width: '50%',
    alignItems: 'center',
  },
  hide: { display: 'none' },
}));

export default useStyles;
